import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import TaskDataTable from "../task/taskDataTable";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import PageHeader from "../../admin/pageHeader/pageheader";

function ProjectIndex() {
  const [UsersData, setUsersData] = useState<any>([]);
  const [TaskData, setTaskData] = useState<any>();
  const { id } = useParams();
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1500);
  const [form] = Form.useForm();

  const user: any = useSelector((state: RootState) => state?.user);

  useEffect(() => {
    getProjectData();
  }, []);

  const getProjectData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query") || "",
        assignedTo: user.id || null,
      };
      const url = API.PROJECT_LIST_EMPLOYEE;
      const response: any = await POST(url, obj);
      setUsersData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch user data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    viewTaskData();
  }, []);

  const viewTaskData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: "string",
        page,
        take: pageSize,
        Projectid: Number(id),
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);
      setTaskData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        Taskid: values.Taskid,
        TaskName: String(values.TaskName),
        startDates: values.startDates,
        endDates: values.endDates,
        Projectid: Number(id),
        assignedTo: user.id || null,
        hourss: Number(values.hourss),
        clientid: UsersData?.[0]?.clientid || null,
        minituess: Number(values.minituess),
        prioritys: values.prioritys,
        descriptions: values.descriptions,
        status: values.status,
      };

      setIsLoading(true);
      const api = API.CREATE_TASK;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: " created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ margin: "10px", display: "flex" }}
        >
          Create Task
        </Button>
      </PageHeader>
      <Card>
        <h2 style={{ textAlign: "center" }}>TASK DETAILS</h2>{" "}
        <TaskDataTable dataSource={TaskData} />
      </Card>
      <Modal
        title="Create Task"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item name="Taskid" label="Taskid">
                <Input placeholder="Enter Taskid" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="TaskName" label="TaskName">
                <Input placeholder="Enter TaskName" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="startDates" label="startDate">
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="endDates" label="endDate">
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="hourss" label="hours">
                <Input placeholder="Enter hours" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="minituess" label="minitues">
                <Input placeholder="Enter minitues" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="prioritys" label="priority">
                <Input placeholder="Enter priority" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="descriptions" label="description">
                <Input placeholder="Enter description" allowClear />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Please select a status!" }]}
              >
                <Select placeholder="Select Status">
                  <Select.Option value="pending">Pending</Select.Option>
                  <Select.Option value="inprogerss">In Progres</Select.Option>
                  <Select.Option value="completed">Completed</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" block>
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ProjectIndex;
